// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"381868a2","409":"313936c7","608":"932392a4","630":"f361c2cf"}[chunkId] + ".chunk.js";
};